import React from "react";
import { NavLink } from "react-router-dom";
import "./RaceMenu.sass";

export const RaceMenu = ({ menuLinks, city }) => {
  const translations = {
    resumen: "Resumen",
    prologo: "Prólogo",
    "etapa-1": "Etapa 1",
    "etapa-2": "Etapa 2",
    "etapa-3": "Etapa 3",
    "etapa-4": "Etapa 4",
    "etapa-5": "Etapa 5",
  };

  const handleRenderMenu = () => {
    if (menuLinks.length > 0) {
      return menuLinks.map((link, index) => (
        <li key={index}>
          <NavLink to={`/rutas/${city}/${link}`}>{translations[link]}</NavLink>
        </li>
      ));
    }
  };

  return (
    <div className="RaceMenu row">
      <nav>
        <ul>{handleRenderMenu()}</ul>
      </nav>
    </div>
  );
};
